import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"margin-top":"10px"} }
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { slot: "content" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"36px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_searchbar, {
              style: {"padding-bottom":"0","height":"40px"},
              mode: "ios",
              modelValue: _ctx.searchKeyword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKeyword) = $event)),
              "show-cancel-button": "focus"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.service)
          ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createElementVNode("p", null, "Our programs use a Real Name system (實名制), with certificates issued jointly by universities and FDMT.", -1)),
                        _createElementVNode("p", _hoisted_1, [
                          _cache[3] || (_cache[3] = _createTextVNode("F5 class and subject teachers, besides career teachers, are encouraged to register by scanning the QR code at ")),
                          _createElementVNode("a", {
                            style: {"color":"var(--ion-color-dark)"},
                            target: "_blank",
                            href: _ctx.service.slideLink
                          }, _toDisplayString(_ctx.service.slideLink.replace("https://", "")), 9, _hoisted_2),
                          _cache[4] || (_cache[4] = _createTextVNode(" to earn the nomination right and be listed below."))
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("p", { style: {"margin-top":"10px"} }, "Meanwhile, please inform FDMT if any of the following teachers are not school staff.", -1))
                      ]),
                      _: 1,
                      __: [5,6]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        (_ctx.showPhones)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSchoolTeachers(false), (user) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  lines: "full",
                  key: user.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      class: "ion-text-wrap",
                      style: {"line-height":"1.15"}
                    }, {
                      default: _withCtx(() => [
                        (user.preferredName && user.preferredName != user.fullName)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(user.preferredName) + " (" + _toDisplayString(user.fullName) + ")", 1))
                          : (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(user.fullName), 1)),
                        (user.teacher?.schoolRoles)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(user.teacher?.schoolRoles), 1))
                          : _createCommentVNode("", true),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", {
                          innerHTML: (user.teacher?.classRoles || []).filter(cr => cr.status != 'removed').map(cr => (`<b>${cr.role} (${cr.classes})</b>`)).join(' & ')
                        }, null, 8, _hoisted_7),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(user.phone), 1),
                          (user.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " | " + _toDisplayString(user.email), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2,
                      __: [7]
                    }, 1024),
                    _createVNode(_component_ion_select, {
                      interface: "popover",
                      placeholder: "Select role",
                      onIonChange: ($event: any) => (_ctx.handleRoleChange($event, user)),
                      value: _ctx.getTeacherServiceRole(user)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: "Active" }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("Active")
                          ])),
                          _: 1,
                          __: [8]
                        }),
                        _createVNode(_component_ion_select_option, { value: "Inactive" }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode("No longer in school")
                          ])),
                          _: 1,
                          __: [9]
                        })
                      ]),
                      _: 2
                    }, 1032, ["onIonChange", "value"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_ion_accordion_group, {
                multiple: true,
                value: Object.keys(_ctx.filteredSchoolTeachers())
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSchoolTeachers(), (teachers, group) => {
                    return (_openBlock(), _createBlock(_component_ion_accordion, {
                      style: {"--min-height":"24px"},
                      key: group,
                      value: group
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          color: "primary",
                          lines: "full",
                          slot: "header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, [
                                  _createElementVNode("b", null, _toDisplayString(group), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            (_ctx.targetTeacherGroups.includes(group))
                              ? (_openBlock(), _createBlock(_component_ion_badge, {
                                  key: 0,
                                  color: teachers.length > 0 ? 'success' : 'danger'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(teachers.length), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"]))
                              : (_openBlock(), _createBlock(_component_ion_badge, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(teachers.length), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers, (user) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              lines: "full",
                              key: user.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, {
                                  class: "ion-text-wrap",
                                  style: {"line-height":"1.15"}
                                }, {
                                  default: _withCtx(() => [
                                    (user.preferredName && user.preferredName != user.fullName)
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(user.preferredName) + " (" + _toDisplayString(user.fullName) + ")", 1))
                                      : (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(user.fullName), 1)),
                                    (user.teacher?.schoolRoles)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(user.teacher?.schoolRoles), 1))
                                      : _createCommentVNode("", true),
                                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                                    _createElementVNode("small", {
                                      innerHTML: (user.teacher?.classRoles || []).filter(cr => cr.status != 'removed').map(cr => (`<b>${cr.role} (${cr.classes})</b>`)).join(' & ')
                                    }, null, 8, _hoisted_14)
                                  ]),
                                  _: 2,
                                  __: [10]
                                }, 1024),
                                _createVNode(_component_ion_select, {
                                  interface: "popover",
                                  placeholder: "Select role",
                                  onIonChange: ($event: any) => (_ctx.handleRoleChange($event, user)),
                                  value: _ctx.getTeacherServiceRole(user)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_select_option, { value: "Active" }, {
                                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                                        _createTextVNode("Active")
                                      ])),
                                      _: 1,
                                      __: [11]
                                    }),
                                    _createVNode(_component_ion_select_option, { value: "Inactive" }, {
                                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                                        _createTextVNode("No longer in school")
                                      ])),
                                      _: 1,
                                      __: [12]
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onIonChange", "value"]),
                                (_ctx.teacherEvent && ['Attended', 'Yes', 'Confirmed'].includes(_ctx.getTeacherSessionResp(user)) && _ctx.getTeacherSessionResp(user, 'nominatedBy'))
                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 0,
                                      slot: "start",
                                      icon: _ctx.checkmark
                                    }, null, 8, ["icon"]))
                                  : (_ctx.teacherEvent)
                                    ? (_openBlock(), _createBlock(_component_ion_checkbox, {
                                        key: 1,
                                        slot: "start",
                                        "onUpdate:modelValue": ($event: any) => (_ctx.onCheckNominee($event, user)),
                                        modelValue: _ctx.nominees.find(n => n.id == user.id) != null
                                      }, null, 8, ["onUpdate:modelValue", "modelValue"]))
                                    : _createCommentVNode("", true),
                                (_ctx.teacherEvent)
                                  ? (_openBlock(), _createBlock(_component_ion_label, {
                                      key: 2,
                                      class: "ion-text-wrap"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h3", null, _toDisplayString(user.fullName) + _toDisplayString((user.preferredName && user.preferredName != user.fullName) ? ` (${user.preferredName})` : ''), 1),
                                        (user.teacher?.schoolRoles)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(user.teacher?.schoolRoles), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.getTeacherSessionResp(user))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                              (_ctx.getTeacherSessionResp(user, 'nominatedBy'))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                    _createVNode(_component_ion_badge, { color: "medium" }, {
                                                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                        _createTextVNode("Nominated")
                                                      ])),
                                                      _: 1,
                                                      __: [13]
                                                    }),
                                                    _cache[14] || (_cache[14] = _createTextVNode(" "))
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (['Attended', 'Yes', 'Confirmed'].includes(_ctx.getTeacherSessionResp(user)))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                    _createVNode(_component_ion_badge, { color: "primary" }, {
                                                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                        _createTextVNode("Applied")
                                                      ])),
                                                      _: 1,
                                                      __: [15]
                                                    }),
                                                    _cache[16] || (_cache[16] = _createTextVNode(" "))
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (['Attended'].includes(_ctx.getTeacherSessionResp(user)))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                    _createVNode(_component_ion_badge, { color: "success" }, {
                                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                        _createTextVNode("Attended")
                                                      ])),
                                                      _: 1,
                                                      __: [17]
                                                    }),
                                                    _cache[18] || (_cache[18] = _createTextVNode(" "))
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (['Unsubscribed', 'No'].includes(_ctx.getTeacherSessionResp(user)))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                                    _createVNode(_component_ion_badge, { color: "danger" }, {
                                                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                        _createTextVNode("No")
                                                      ])),
                                                      _: 1,
                                                      __: [19]
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_ion_toolbar, { class: "ion-text-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_grid, {
              style: {"padding-top":"0"},
              fixed: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  class: "no-text-transform",
                  color: "success",
                  expand: "block",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitNomination(_ctx.schoolTeachers, _ctx.nominees)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.arrowForward
                    }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, "Nominate " + _toDisplayString(_ctx.nominees.length) + " teacher" + _toDisplayString(_ctx.nominees.length > 1 ? 's' : ''), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.nominees.length > 0]
        ])
      ]),
      _: 1
    })
  ], 64))
}